import React, { useState } from 'react';
import { navLinks, businessInfo } from '../data/mock';
import { Phone, Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#1a1c1b]/95 backdrop-blur-sm border-b border-[#4a2a10]/50">
      <div className="container mx-auto px-5 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="#home" className="text-[#f97316] font-black text-xl md:text-2xl tracking-tight">
            {businessInfo.name}
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={link.href}
                className="text-[#f97316] hover:text-[#f97316]/80 transition-colors duration-300 font-medium text-sm uppercase tracking-wide"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Phone Button - Desktop */}
          <a
            href={`tel:${businessInfo.phone.replace(/\s/g, '')}`}
            className="hidden md:flex items-center gap-2 bg-[#f97316] text-white px-5 py-2.5 rounded-full font-semibold text-sm uppercase tracking-wide hover:scale-[1.02] active:scale-[0.98] transition-transform duration-300"
          >
            <Phone size={16} />
            <span>{businessInfo.phone}</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-[#f97316] p-2"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-[#4a2a10]/50">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.href}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-[#f97316] hover:text-[#f97316]/80 transition-colors duration-300 font-medium text-sm uppercase tracking-wide py-2"
                >
                  {link.label}
                </a>
              ))}
              <a
                href={`tel:${businessInfo.phone.replace(/\s/g, '')}`}
                className="flex items-center justify-center gap-2 bg-[#f97316] text-white px-5 py-3 rounded-full font-semibold text-sm uppercase tracking-wide mt-2"
              >
                <Phone size={16} />
                <span>{businessInfo.phone}</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
